module.exports = __webpack_public_path__ + "img/category-new-released-hover.cbad2147.png";